import type { LegacyLogo, LogoEntity, LogoStylesLegacy } from './schemas';
import { createLogoStylesLegacy } from './schemas';

export type CreateLogoOptions = {
    styles?: Partial<LogoStylesLegacy>;
};

/**
 * Factory for the current legacy logo entity — matches the persisted widget JSON
 * shape: `{ id, name: 'logo', columnId, data, styles }`. No variant argument: the
 * logo has a single (specific-section) placement.
 */
export function createLegacyLogo(options?: CreateLogoOptions): LegacyLogo {
    return {
        id: '',
        name: 'logo',
        columnId: '',
        data: {
            image: null,
        },
        styles: createLogoStylesLegacy(options?.styles),
    };
}

/**
 * Convenience entry-point that returns whichever shape is the current default for
 * new logo widgets. While only `legacy` exists, this delegates to
 * {@link createLegacyLogo}.
 */
export function createLogo(options?: CreateLogoOptions): LogoEntity {
    return createLegacyLogo(options);
}
